import { motion } from "framer-motion";
import { Eye, Crosshair } from "lucide-react";

export const AboutSection = () => {
  return (
    <section 
      id="nosotros"
      data-testid="about-section"
      className="relative py-24 bg-dark-paper"
    >
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-neon-green/5 to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Quiénes Somos */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-20"
        >
          <span className="text-neon-magenta text-sm font-bold uppercase tracking-widest">
            Quiénes Somos
          </span>
          
          <h2 className="mt-4 text-4xl md:text-5xl font-black uppercase tracking-tight text-white">
            Más que un gimnasio,
            <br />
            <span className="text-neon-cyan text-glow-cyan">una familia.</span>
          </h2>
          
          <p className="mt-6 text-lg text-gray-300 leading-relaxed">
            Somos un equipo de entrenadores apasionados por la transformación real. 
            Creemos que cada persona merece un acompañamiento genuino, no solo una 
            rutina de ejercicios. En Inspirion GYM, nos importa tu progreso tanto 
            como a ti mismo.
          </p>
          
          <p className="mt-4 text-lg text-gray-300 leading-relaxed">
            Nacimos de la frustración de ver gimnasios llenos de máquinas pero 
            vacíos de compromiso con sus alumnos. Aquí, eso es diferente. 
            <span className="text-neon-green font-semibold"> Tu éxito es nuestro éxito.</span>
          </p>
        </motion.div>

        {/* Misión y Visión */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Misión */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative p-8 bg-dark-card border-l-4 border-l-neon-green"
          >
            <div 
              className="inline-flex items-center justify-center w-14 h-14 mb-6 bg-neon-green/10"
              style={{ boxShadow: "0 0 20px rgba(0, 255, 0, 0.3)" }}
            >
              <Crosshair className="w-7 h-7 text-neon-green" />
            </div>
            
            <h3 className="text-2xl font-bold text-white uppercase tracking-tight mb-4">
              Nuestra Misión
            </h3>
            
            <p className="text-gray-400 leading-relaxed">
              Ayudar a las personas a entrenar de forma segura, constante y con 
              resultados reales. Queremos que cada alumno se sienta acompañado, 
              motivado y orgulloso de su transformación física y mental.
            </p>
          </motion.div>

          {/* Visión */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative p-8 bg-dark-card border-l-4 border-l-neon-cyan"
          >
            <div 
              className="inline-flex items-center justify-center w-14 h-14 mb-6 bg-neon-cyan/10"
              style={{ boxShadow: "0 0 20px rgba(0, 255, 255, 0.3)" }}
            >
              <Eye className="w-7 h-7 text-neon-cyan" />
            </div>
            
            <h3 className="text-2xl font-bold text-white uppercase tracking-tight mb-4">
              Nuestra Visión
            </h3>
            
            <p className="text-gray-400 leading-relaxed">
              Ser el gimnasio de referencia en Rancagua para transformación real 
              y acompañamiento humano. Un lugar donde las personas no solo cambian 
              su cuerpo, sino que descubren su mejor versión.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
